import { render, staticRenderFns } from "./DocumentFormModal.vue?vue&type=template&id=1ebf9a15&"
import script from "./DocumentFormModal.vue?vue&type=script&lang=js&"
export * from "./DocumentFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports